import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Companies from '../views/Companies.vue'
import Investors from '../views/Investors.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/companies',
    name: 'Companies',
    component: Companies
  },
  {
    path: '/investors',
    name: 'Investors',
    component: Investors
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
